<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M13.384,23.998c-0.135,0-0.27-0.018-0.4-0.053c-0.396-0.106-0.728-0.36-0.933-0.716c-0.237-0.411-0.271-0.918-0.089-1.357
		l1.244-2.851l-2.233-2.2c-0.267-0.232-0.445-0.597-0.471-0.988c-0.026-0.396,0.103-0.778,0.364-1.076
		c0.281-0.322,0.686-0.507,1.109-0.507c0.021,0,0.041,0,0.062,0.001l2.493,0l1.342-2.889c0.208-0.395,0.536-0.669,0.933-0.791
		c0.148-0.046,0.302-0.069,0.456-0.069c0.251,0,0.501,0.063,0.725,0.182c0.276,0.147,0.5,0.371,0.646,0.648
		c0.004,0.008,0.017,0.033,0.02,0.042l1.335,2.877l2.538-0.001c0.369,0,0.724,0.14,0.999,0.395c0.291,0.269,0.46,0.636,0.476,1.032
		c0.018,0.445-0.163,0.87-0.495,1.167l-2.189,2.173l1.237,2.844c0.162,0.388,0.163,0.808,0.006,1.188
		c-0.156,0.379-0.452,0.675-0.831,0.832c-0.186,0.077-0.384,0.117-0.588,0.117l0,0c-0.271,0-0.537-0.071-0.769-0.205l-3.111-1.75
		l-3.119,1.754C13.914,23.927,13.65,23.998,13.384,23.998z M17.261,20.431c0.128,0,0.255,0.033,0.367,0.096l3.487,1.961l0.027,0.009
		c0.022-0.006,0.028-0.012,0.032-0.022c0.004-0.009,0.004-0.017,0-0.027l-1.437-3.303c-0.125-0.286-0.062-0.612,0.159-0.832
		c0,0,2.583-2.563,2.583-2.563l-2.97,0c-0.291,0-0.558-0.17-0.68-0.434L17.3,12.023c-0.004-0.006-0.01-0.011-0.017-0.015
		l-0.038-0.003c-0.013,0.004-0.023,0.012-0.029,0.024l-1.526,3.287c-0.123,0.264-0.39,0.434-0.68,0.434h-2.985l2.603,2.564
		c0.22,0.216,0.284,0.552,0.161,0.834l-1.445,3.311c0,0,0,0,0,0c0.001,0,0.002,0.011,0.007,0.02
		c0.005,0.009,0.012,0.014,0.021,0.016c0.001,0,0.03-0.005,0.031-0.006l3.49-1.963C17.006,20.464,17.133,20.431,17.261,20.431z
		 M11.986,15.751c0,0,0.004,0,0.005-0.001C11.987,15.751,11.986,15.751,11.986,15.751z"/>
	<path d="M0.75,15.001c-0.031,0-0.062-0.002-0.093-0.006c-0.411-0.052-0.703-0.428-0.651-0.838C0.43,10.79,3.311,8.251,6.706,8.251
		h0.085c2.296,0,4.415,1.149,5.669,3.074c0.226,0.346,0.127,0.812-0.219,1.038c-0.122,0.08-0.264,0.122-0.409,0.122l0,0
		c-0.255,0-0.49-0.127-0.629-0.341c-0.976-1.498-2.627-2.392-4.415-2.392H6.707c-2.642,0-4.884,1.975-5.214,4.594
		C1.447,14.719,1.127,15.001,0.75,15.001z"/>
	<path d="M6.75,8.251c-2.275,0-4.125-1.85-4.125-4.125s1.85-4.125,4.125-4.125s4.125,1.85,4.125,4.125S9.024,8.251,6.75,8.251z
		 M6.75,1.501c-1.447,0-2.625,1.178-2.625,2.625S5.302,6.751,6.75,6.751s2.625-1.178,2.625-2.625S8.197,1.501,6.75,1.501z"/>
	<path d="M16.5,6.751c-1.861,0-3.375-1.514-3.375-3.375s1.514-3.375,3.375-3.375s3.375,1.514,3.375,3.375S18.361,6.751,16.5,6.751z
		 M16.5,1.501c-1.034,0-1.875,0.841-1.875,1.875s0.841,1.875,1.875,1.875s1.875-0.841,1.875-1.875S17.534,1.501,16.5,1.501z"/>
	<path d="M20.4,9.751c-0.267,0-0.516-0.144-0.649-0.375c-0.668-1.155-1.915-1.873-3.254-1.873c-0.654,0-1.301,0.174-1.869,0.503
		c-0.357,0.206-0.676,0.468-0.947,0.779c-0.142,0.163-0.348,0.256-0.565,0.256l0,0c-0.182,0-0.357-0.066-0.494-0.186
		c-0.151-0.132-0.241-0.314-0.254-0.514c-0.013-0.2,0.052-0.393,0.184-0.544c0.38-0.435,0.826-0.801,1.326-1.09
		c0.796-0.46,1.702-0.704,2.619-0.704c1.874,0,3.619,1.005,4.554,2.622c0.207,0.358,0.084,0.818-0.274,1.025
		C20.661,9.716,20.531,9.751,20.4,9.751z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'multiple-actions-star',
    },
    name: {
      type: String,
      required: false,
      default: 'MultipleActionsStar',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>